/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/function-component-definition */
/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
import React, { useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import TextInput from '../../components/TextField/TextField';
import { Entry } from '../../redux/entrySlice';
import { TableContext } from '../../contexts/tableContext';
import styles from './create.module.scss';
import { CapitalizeFirstLetter } from '../../utilityFunctions/utilsFunctions';

const CreateRoles = React.memo(() => {
  const permissions = ['create', 'edit', 'view', 'delete'];
  const viewOnly = 'view';
  const { dashboardStyle } = useContext(TableContext);
  const { setDashboardHeader } = useContext(TableContext);
  const { bodyStyle } = useContext(TableContext);
  const { formthemeStyle, permissionboxStyle } = useContext(TableContext);
  const { bodyheader } = useContext(TableContext);
  const { errormsgStyle } = useContext(TableContext);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [submiting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [status, setStatus] = useState([]);
  const [sections, setSections] = useState();
  // const actions = [];
  // const [checkedState, setCheckedState] = useState(new Array(actions.length).fill(false));

  useEffect(() => {
    window.scrollTo(0, 0);
    setDashboardHeader('Add Role Details');
    const actionData = {};
    actionData.actionUrl = 'roles/modules ';
    actionData.actionMethod = 'get';
    dispatch(Entry(actionData)).then((resp) => {
      setSections(resp.payload.data.Menu);
      const tempData = [];
      resp.payload.data.Menu.forEach((element) => {
        const newObj = {};
        newObj.section = `${element.modules}`;
        if (element.subMenu) {
          newObj.submenu = [];
          element.subMenu.forEach((subItem) => {
            const subObj = {};
            subObj.section = `${subItem.modules}`;
            permissions.forEach((permission) => {
              subObj[`${permission}`] = false;
            });
            newObj.submenu.push(subObj);
            newObj[`${viewOnly}`] = false;
          });
        } else if (element.modules === 'dashboard') {
          newObj[`${viewOnly}`] = false;
        } else {
          permissions.forEach((permission) => {
            newObj[`${permission}`] = false;
          });
        }
        tempData.push(newObj);
      });
      setStatus(tempData);
    });
  }, []);
  function onSubmitdata(data) {
    setSubmitting(true);
    data.permissions = status;
    const apiData = {
      name: data.name,
      permissions: data.permissions,
    };
    data.actionUrl = 'roles/';
    data.actionMethod = 'post';
    data.apiData = apiData;
    setError(null);
    dispatch(Entry(data)).then((resp) => {
      setSubmitting(false);
      if (resp.payload.code === 201) {
        navigate(-1);
      } else if (resp.payload.code === 401 || resp.payload.code === 400) {
        setError(resp.payload.message);
      } else {
        setError(resp.payload.message);
      }
    });
  }

  const handleOnChange = (e, permission, section, subSection, isSubmenu = false) => {
    if (e.target.value === 'select-all') {
      status.forEach((element, index) => {
        document.getElementById(`select-all-${element.section}`).checked = e.target.checked;
        if (element.submenu) {
          status[index][`${viewOnly}`] = e.target.checked;
          document.getElementById(`custom-checkbox-${element.section}-${viewOnly}`).checked =
            e.target.checked;
          element.submenu.forEach((subItem, subIndex) => {
            permissions.forEach((permissionItem) => {
              status[index].submenu[subIndex][`${permissionItem}`] = e.target.checked;
              document.getElementById(
                `custom-checkbox-${element.section}-${subItem.section}-${permissionItem}`
              ).checked = e.target.checked;
            });
          });
        } else if (element.section === 'dashboard') {
          status[index][`${viewOnly}`] = e.target.checked;
          document.getElementById(`custom-checkbox-${element.section}-${viewOnly}`).checked =
            e.target.checked;
        } else
          permissions.forEach((permissionItem) => {
            status[index][`${permissionItem}`] = e.target.checked;
            document.getElementById(
              `custom-checkbox-${element.section}-${permissionItem}`
            ).checked = e.target.checked;
          });
        setStatus(status);
      });
    } else if (e.target.value === `select-all-${section}`) {
      status.forEach((element, index) => {
        if (element.section === section) {
          if (element.submenu) {
            status[index][`${viewOnly}`] = e.target.checked;
            document.getElementById(`custom-checkbox-${section}-${viewOnly}`).checked =
              e.target.checked;
            element.submenu.forEach((subItem, subIndex) => {
              permissions.forEach((permissionItem) => {
                status[index].submenu[subIndex][`${permissionItem}`] = e.target.checked;
                document.getElementById(
                  `custom-checkbox-${section}-${subItem.section}-${permissionItem}`
                ).checked = e.target.checked;
              });
            });
          } else if (element.section === 'dashboard') {
            status[index][`${viewOnly}`] = e.target.checked;
            document.getElementById(`custom-checkbox-${element.section}-${viewOnly}`).checked =
              e.target.checked;
          } else
            permissions.forEach((permissionItem) => {
              status[index][`${permissionItem}`] = e.target.checked;
              document.getElementById(`custom-checkbox-${section}-${permissionItem}`).checked =
                e.target.checked;
            });
          if (e.target.checked === false)
            document.getElementById('select-all').checked = e.target.checked;
          else {
            const falseFlag = [];
            status.forEach((sectionItems) => {
              if (document.getElementById(`select-all-${sectionItems.section}`).checked === false) {
                document.getElementById('select-all').checked = false;
                falseFlag.push(`select-all-${sectionItems.section}`);
              }
            });
            if (falseFlag.length === 0)
              document.getElementById('select-all').checked = e.target.checked;
          }

          setStatus(status);
        }
      });
    } else {
      status.forEach((element, index) => {
        if (element.section === section) {
          if (isSubmenu) {
            element.submenu.forEach((subItem, subIndex) => {
              if (subItem.section === subSection)
                status[index].submenu[subIndex][`${permission}`] = e.target.checked;
            });
          } else {
            status[index][`${permission}`] = e.target.checked;
          }
          if (e.target.checked === false) {
            document.getElementById('select-all').checked = e.target.checked;
            document.getElementById(`select-all-${element.section}`).checked = e.target.checked;
          } else {
            const falseFlag = [];
            status.forEach((sectionItems, sectionIndex) => {
              if (sectionItems.submenu) {
                const falsesubFlag = [];
                if (!status[sectionIndex][`${viewOnly}`])
                  falsesubFlag.push(status[sectionIndex][`${viewOnly}`]);
                sectionItems.submenu.forEach((subItem) => {
                  permissions.forEach((permissionItem) => {
                    if (
                      !document.getElementById(
                        `custom-checkbox-${sectionItems.section}-${subItem.section}-${permissionItem}`
                      ).checked
                    )
                      falsesubFlag.push(
                        `custom-checkbox-${sectionItems.section}-${subItem.section}-${permissionItem}`
                      );
                  });
                });
                if (falsesubFlag.length === 0)
                  document.getElementById(`select-all-${sectionItems.section}`).checked =
                    e.target.checked;
              } else if (sectionItems.section === 'dashboard') {
                if (status[sectionIndex][`${viewOnly}`])
                  document.getElementById(`select-all-${sectionItems.section}`).checked =
                    e.target.checked;
              } else {
                const falsesubFlag = [];
                permissions.forEach((permissionItem) => {
                  if (
                    !document.getElementById(
                      `custom-checkbox-${sectionItems.section}-${permissionItem}`
                    ).checked
                  )
                    falsesubFlag.push(`custom-checkbox-${sectionItems.section}-${permissionItem}`);
                });
                if (falsesubFlag.length === 0)
                  document.getElementById(`select-all-${sectionItems.section}`).checked =
                    e.target.checked;
              }
              if (document.getElementById(`select-all-${sectionItems.section}`).checked === false) {
                document.getElementById('select-all').checked = false;
                falseFlag.push(`select-all-${sectionItems.section}`);
              }
            });
            if (falseFlag.length === 0)
              document.getElementById('select-all').checked = e.target.checked;
          }
          setStatus(status);
        }
      });
    }
  };

  return (
    <div className={styles[bodyStyle]}>
      <div className={styles[dashboardStyle]} id={styles.dashboardcont2}>
        <form onSubmit={handleSubmit(onSubmitdata)}>
          <div className="form_head">
            <div
              value="Back"
              onClick={() => {
                navigate(-1);
              }}
              className={`${styles.arrowback} backBtn`}
            >
              <svg
                className="mr-1"
                width="17"
                height="14"
                viewBox="0 0 17 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.5 6.00003H3.64L7.27 1.64003C7.43974 1.43581 7.5214 1.17253 7.49702 0.908108C7.47264 0.643682 7.34422 0.39977 7.14 0.230032C6.93578 0.060293 6.6725 -0.0213689 6.40808 0.0030108C6.14365 0.0273905 5.89974 0.155815 5.73 0.360032L0.73 6.36003C0.696361 6.40776 0.666279 6.45789 0.64 6.51003C0.64 6.56003 0.64 6.59003 0.57 6.64003C0.524674 6.75469 0.500941 6.87674 0.5 7.00003C0.500941 7.12332 0.524674 7.24537 0.57 7.36003C0.57 7.41003 0.57 7.44003 0.64 7.49003C0.666279 7.54217 0.696361 7.59231 0.73 7.64003L5.73 13.64C5.82402 13.7529 5.94176 13.8437 6.07485 13.9059C6.20793 13.9681 6.35309 14.0003 6.5 14C6.73365 14.0005 6.96009 13.9191 7.14 13.77C7.24126 13.6861 7.32496 13.583 7.38631 13.4666C7.44766 13.3503 7.48546 13.223 7.49754 13.092C7.50961 12.961 7.49573 12.829 7.45669 12.7034C7.41764 12.5777 7.3542 12.4611 7.27 12.36L3.64 8.00003H15.5C15.7652 8.00003 16.0196 7.89467 16.2071 7.70714C16.3946 7.5196 16.5 7.26525 16.5 7.00003C16.5 6.73482 16.3946 6.48046 16.2071 6.29292C16.0196 6.10539 15.7652 6.00003 15.5 6.00003Z"
                  fill=""
                />
              </svg>
              Back
            </div>
            <div>
              <span className="sub_btn">
                <input
                  className={styles.formbtn}
                  type="submit"
                  disabled={submiting}
                  value={submiting ? 'Please wait..' : 'Submit'}
                />
              </span>
            </div>
          </div>

          <div className={`${styles[formthemeStyle]} addRole_container`} id={styles.addform}>
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-4 col-sm-4 add_input">
                  <TextInput
                    className={styles.inputbox}
                    classNamedark={styles.inputbox1}
                    labelstyle={styles.formlabel}
                    label="Role Name"
                    fieldName="name"
                    placeHolder="Enter Role Name"
                    register={register}
                    errors={errors}
                    isRequired
                    mandatory
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-6 col-sm-12" style={{ padding: '0px 12px' }}>
                  <input
                    type="checkbox"
                    id="select-all"
                    name="select-all"
                    value="select-all"
                    onChange={(e) => handleOnChange(e, 'all', 'all')}
                  />
                  <label htmlFor="select-all" className={styles.selectlabel}>
                    Select all
                  </label>
                </div>
              </div>
              <br />
              {sections &&
                sections?.map((value) => (
                  <div className="row">
                    <div className="col-md-6 col-sm-12">
                      <div className={styles[permissionboxStyle]} id={styles.permissionbox}>
                        <div className={styles.permission_title}>
                          <input
                            type="checkbox"
                            id={`select-all-${value.modules}`}
                            name={`select-all-${value.modules}`}
                            value={`select-all-${value.modules}`}
                            onChange={(e) => handleOnChange(e, 'all', value.modules)}
                          />
                          <h5
                            htmlFor={`select-all-${value.modules}`}
                            className={styles[bodyheader]}
                            id={styles.addheading}
                          >
                            {CapitalizeFirstLetter(value.name)}
                          </h5>
                        </div>
                        {value.name === 'Dashboard' || value.subMenu ? (
                          <ul>
                            <li>
                              <input
                                type="checkbox"
                                id={`custom-checkbox-${value.modules}-${viewOnly}`}
                                name={viewOnly}
                                value={viewOnly}
                                onChange={(e) => handleOnChange(e, viewOnly, value.modules)}
                              />
                              <label
                                htmlFor={`custom-checkbox-${value.modules}-${viewOnly}`}
                                className={styles.selectlabel}
                              >
                                {viewOnly}
                              </label>
                            </li>
                          </ul>
                        ) : (
                          <ul>
                            {permissions.map((name) => (
                              <li>
                                <input
                                  type="checkbox"
                                  id={`custom-checkbox-${value.modules}-${name}`}
                                  name={name}
                                  value={name}
                                  onChange={(e) => handleOnChange(e, name, value.modules)}
                                />
                                <label
                                  htmlFor={`custom-checkbox-${value.modules}-${name}`}
                                  className={styles.selectlabel}
                                >
                                  {name}
                                </label>
                              </li>
                            ))}
                          </ul>
                        )}

                        {value.subMenu ? (
                          <div className="mt-3 mb-3">
                            <h5 className={styles[bodyheader]} id={styles.addheading}>
                              {CapitalizeFirstLetter('submenu')}
                            </h5>
                          </div>
                        ) : (
                          ''
                        )}

                        {value.subMenu
                          ? value.subMenu.map((subvalue) => (
                              <div className="row">
                                <div className="col-md-12 col-sm-12">
                                  <div
                                    className={styles[permissionboxStyle]}
                                    id={styles.permissionbox}
                                  >
                                    <h5
                                      className={styles[bodyheader]}
                                      id={styles.addheading}
                                      styles={{ marginLeft: '0px' }}
                                    >
                                      {CapitalizeFirstLetter(subvalue.name)}
                                    </h5>
                                    <ul className="mt-3">
                                      {permissions.map((name) => (
                                        <li>
                                          <input
                                            type="checkbox"
                                            id={`custom-checkbox-${value.modules}-${subvalue.modules}-${name}`}
                                            name={name}
                                            value={name}
                                            onChange={(e) =>
                                              handleOnChange(
                                                e,
                                                name,
                                                value.modules,
                                                subvalue.modules,
                                                true
                                              )
                                            }
                                          />
                                          <label
                                            htmlFor={`custom-checkbox-${value.modules}-${subvalue.modules}-${name}`}
                                            className={styles.selectlabel}
                                          >
                                            {name}
                                          </label>
                                        </li>
                                      ))}
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            ))
                          : ''}
                      </div>
                    </div>
                  </div>
                ))}
              {error && <h6 className={styles[errormsgStyle]}>{error}</h6>}
            </div>
          </div>
        </form>
      </div>
    </div>
  );
});

export default CreateRoles;
